import { createContext, useContext } from 'react';
import { useStandalone } from 'services/users';
import useBreadcrumbs from './useBreadcrumbs';
import useDeviceOS from './useDeviceOS';
import useDisplayMode from './useDisplayMode';
import useMediaQuery from './useMediaQuery';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const Config = createContext();

export function ConsoleProvider({ children }) {
  const breadcrumbs = useBreadcrumbs();
  const device = useDeviceOS();
  const isStandalone = useDisplayMode();
  const screen = useMediaQuery();
  const router = useRouter();

  const fixed = screen.isLandscape && device === 'ios';
  const initialPath = useRef(null);

  useEffect(() => {
    const pn = router.pathname;
    const ap = router.asPath;

    if (initialPath.current === null) initialPath.current = ap;
    if (pn === '/' && pn !== ap) router.replace(ap);
  }, [router.asPath]);

  useStandalone(isStandalone, device, screen);

  return (
    <Config.Provider
      value={{
        ...breadcrumbs,
        device,
        initialPath,
        isStandalone,
        fixed,
        screen,
      }}
    >
      {children}
    </Config.Provider>
  );
}

export const useConsole = () => useContext(Config);
